var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.areDictionariesLoaded || _vm.isProcessing || _vm.isFetching || _vm.isProp(_vm.show))?_c('div',_vm._l((_vm.isDesktop ? 10 : 1),function(skeleton){return _c('v-skeleton-loader',{key:'skeleton' + skeleton,attrs:{"type":"table-heading, list-item-three-line"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }